<template>
  <div
    :class="'SocialFeed ' + _uid"
  >
    <carousel
        v-if="feed_list && feed_list.data"
        role="feed"
        class="overflow-visible overflow-hidden-lg mt-lg-1 override-base-carousel"
        :options="{
          slidesPerView: 1.1,
          loop: false,
          pagination: {
            dynamicBullets: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 3,
            }
          },
        }"
    >
        <carousel-item v-for="(feed_item,itemindex) in feed_list.data" :key="_uid + feed_item.media_id + '-' + itemindex">
          <social-card
            :image="{src: '@images/close-modal-icon.png', alt: 'Barilla'}"
            :link="feed_item.link"
            :data-modal-id="feed_item.carousel && feed_item.carousel.length > 0 ? 'overlay-' + _uid : null"
            :data-created-on="feed_item.created_on"
            :data-variant="dataVariant"
            :data-text-capped="hasMedia(feed_item)"
            :data-type="feed_item.type"
            :data-end-feed-id="'SocialFeed-end-anchor-' + _uid"
            :data-end-feed-label="dataCardEndFeedLabel"
            :data-external-social-button-title="dataExternalSocialButtonTitle"
            @open-modal="openModal(itemindex)"
          >
            <template v-if="feed_item.formatted_name" slot="content">
              <p class="content">
                <span v-html="feed_item.formatted_name"> </span>
              </p>
            </template>
            <template slot="profile-pic">
              <img src="@images/barilla-tw-pic.png" alt="profile pic" />
            </template>

            <template slot="username">
                {{ feed_item.username ? feed_item.username  : 'Barilla'}}
            </template>
            <template v-if="feed_item.image && feed_item.image.source" slot="postimage">
              <img :src="feed_item.image.source" alt="titolo post">
            </template>


          </social-card>
        </carousel-item>
    </carousel>


    <div :id="'overlay-'+ _uid" class="overlay" @click="closeModal()">
        <carousel
          v-if="activeModal"
          role="feed"
          class="subcarousel overflow-visible overflow-hidden-lg"
          @slideChange="onInnerNavigation('overlay-' + _uid)"
          :options="{
              slidesPerView: 1,
              loop: true,
              observer: true,
              observeParents: true,
              parallax: true,
              centeredSlides: true,
              initialSlide: activeSlide,
              navigation: {
                nextEl: '.inner-swiper-button-next',
                prevEl: '.inner-swiper-button-prev',
              }
            }"
      >
        <carousel-item v-for="(feed_item, indexfullscreen) in feed_list.data" class="fullscreen" :key="_uid + '-subitem-fullscreen-' + indexfullscreen">
          <social-card
            class="fullscreen"
            :image="{src: '@images/close-modal-icon.png', alt: 'Barilla'}"
            :link="feed_item.link"
            :data-variant="dataVariant"
            :data-created-on="feed_item.created_on"
            :data-end-feed-id="'SocialFeed-end-anchor-' + _uid"
            :data-end-feed-label="dataCardEndFeedLabel"
            :data-external-social-button-title="dataExternalSocialButtonTitle"
          >

          <template v-if="feed_item.username" slot="username">
            <p class="user p-0 m-0">
              {{ feed_item.username }}
            </p>
          </template>
          <template  slot="content">
            <p v-if="feed_item.formatted_name" class="content">
              <span v-html="feed_item.formatted_name"></span>
            </p>
          </template>
          <template v-if="feed_item.carousel && feed_item.carousel.length > 0" slot="postimage">
                <carousel
                    v-if="feed_list && feed_list.data"
                    @slideChange="onInnerNavigation('overlay-' + _uid, true)"
                    class="overflow-hidden override-base-carousel media-carousel"
                    :options="{
                      slidesPerView: 1,
                      loop: false,
                      pagination: false,
                      centeredSlides: true,
                      effect: 'fade',
                      navigation: {
                        nextEl: '.inner-sub-swiper-button-next',
                        prevEl: '.inner-sub-swiper-button-prev',
                      }
                    }"
                >
                <carousel-item v-for="(tweet_carousel_item, index) in feed_item.carousel" :key="_uid + '-carousel-subitem' + index">
                  <div class="media-wrapper">
                    <template v-if="tweet_carousel_item.source && tweet_carousel_item.type == 'image'">
                      <img  style="width: 100%;margin-bottom: -7px;" :src="tweet_carousel_item.source" alt="titolo post">
                    </template>
                    <template v-if="tweet_carousel_item.source && tweet_carousel_item.type == 'video'">
                      <video style="width: 100%;margin-bottom: -7px;" autoplay loop muted controls>
                        <source :src="tweet_carousel_item.source" type="video/mp4">
                      </video>
                    </template>
                  </div>
                </carousel-item>
              </carousel>
          </template>
          </social-card>
        </carousel-item>
        </carousel>
        <div class="close-modal-social-icon">
        <img :id="'overlay-'+ _uid + '-close'" class="close-modal" src='@images/close-modal-icon.png' alt="close" @click="closeModal()">
        </div>
    </div>
    <div class="end-feed-anchor" :id="'SocialFeed-end-anchor-' + _uid">{{ dataAnchorEndFeedLabel }}</div>
  </div>
</template>

<script>
import Icon from '@components/atoms/icon'
import Carousel from '@components/carousel/carousel'
import CarouselItem from '@components/carousel/carousel-item'
import SocialCard from '@components/social-card'
import axios from "axios";
  export default {
    name: 'SocialFeed',
    components: {
      Icon, Carousel, CarouselItem, SocialCard
    },
    props: {
      dataApiUrl: {
        type: String, required: true
      },
      dataCardEndFeedLabel: {
        type: String, required: true
      },
      dataAnchorEndFeedLabel: {
        type: String, required: true
      },
      dataExternalSocialButtonTitle: {
        type: String, required: true
      },
      dataVariant: {
        type: String,
           validator(value) {
            return ['instagram', 'in/x'].includes(value)
          } },
    },
    data() {
      return {
        feed_list: [],
        activeModal: false,
        activeSlide: 0,
      };
  },
  methods: {
    hasMedia(feed_item) {
      return (feed_item.video && feed_item.video.source) || (feed_item.image && feed_item.image.source) ? true : false
    },
    onInnerNavigation(overlayId, forceResize = false) {
      document.querySelectorAll('#' + overlayId + ' video').forEach(vid => { vid.muted = true; });
      if (forceResize) {
        window.dispatchEvent(new Event('resize'));
      }
    },
    openModal(activeSlide) {
      this.activeModal = true;
      this.activeSlide = activeSlide;
    },
    closeModal() {
      this.activeModal = false;
    },
    async callSocialsApi() {
      try {
        const response = await axios.get(this.dataApiUrl);
        if (response.data) {
          //if (this.dataVariant === 'instagram') {
            response.data.data?.forEach(e => {
              if ((e.image?.source || e.video?.source) && (!e.carousel || e.carousel.length == 0)) {
                if (e.image?.source) {
                  e.carousel = [
                    {
                      "id": e.media_id,
                      "width": 1080,
                      "height": 1080,
                      "type": "image",
                      "source": e.large_image.source ? e.large_image.source : e.image.source,
                    }
                  ]
                }
                if (e.video?.source) {
                  e.carousel = [
                    {
                      "id": e.media_id,
                      "width": 1080,
                      "height": 1080,
                      "type": "video",
                      "source": e.video.source,
                    }
                  ]
                }
              }
            });
          //}
          this.feed_list = response.data;
        }
      } catch (e) {
        console.error(e)
      }
      }
  },
  mounted() {
    this.callSocialsApi()
  }
  }
</script>

<style lang="scss" scoped>
  @import "~$scss/_variables";

  .SocialFeed {
    position: relative;
    .end-feed-anchor {
      position: absolute;
      bottom: 0;
      left: -999999px;
      background-color: white;
      border-radius: 4px;
      border: 0.5px solid;
    }

    .end-feed-anchor:focus {
      left: 0px;
    }
    .overlay {
      background-color:#00142FBF;
      position:fixed;
      width:100%;
      height: 100%;
      overflow-y: auto;
      top:0px;
      left:0px;
      z-index:9999;
      display:none
    }
    .close-modal {
      width:100%
    }
    .media-carousel {
      ::v-deep.swiper-slide {
        width: 100%!important;
        margin-right: 0px!important;
      }
      ::v-deep .swiper-button-next,::v-deep .swiper-button-prev {
        top: 50%!important;
        background: rgba(#FFFFFF, 0.8);
        width: 20px;
        height: 20px;
        &::before {
          width: 6px;
          height: 6px;
          border-color: rgba(#707070, 01);
        }
      }
      ::v-deep .swiper-button-next {
        right: 10px;
      }
      ::v-deep .swiper-button-prev {
        left: 10px;
      }
    }
  }
</style>
